import { useState } from 'react';

const SHOW_DEBUG_KEY = 'messages_show_debug';
const GROUP_BY_CHANNEL_KEY = 'messages_group_by_channel';

export interface MessagesPreferences {
  showInternal: boolean;
  changeShowInternal: (next: boolean) => void;
  groupByChannel: boolean;
  changeGroupByChannel: (next: boolean) => void;
}

/**
 * The two switches of the transcript, remembered in this browser. A link that
 * asks for the internal messages shows them whatever was remembered.
 */
export function useMessagesPreferences(internal: 1 | undefined): MessagesPreferences {
  const [showInternal, setShowInternal] = useState(
    () => internal === 1 || readStored(SHOW_DEBUG_KEY) === 'true',
  );
  const [groupByChannel, setGroupByChannel] = useState(
    () => readStored(GROUP_BY_CHANNEL_KEY) !== 'false',
  );

  function changeShowInternal(next: boolean) {
    writeStored(SHOW_DEBUG_KEY, String(next));
    setShowInternal(next);
  }

  function changeGroupByChannel(next: boolean) {
    writeStored(GROUP_BY_CHANNEL_KEY, String(next));
    setGroupByChannel(next);
  }

  return { showInternal, changeShowInternal, groupByChannel, changeGroupByChannel };
}

function readStored(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    /* localStorage may be unavailable (Safari private mode) */
    return null;
  }
}

function writeStored(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* localStorage may be unavailable (Safari private mode) */
  }
}
